module.exports = __webpack_public_path__ + "img/icon-calendar.29a15147.svg";